import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, Input, OnChanges, Injector, ChangeDetectorRef } from '@angular/core';

/**
 * declare Jquery
 * */
declare let $: any;

@Component({
    selector: 'industry-distribution',
    templateUrl: './industry-distribution.html',
    styleUrls: ['./industry-distribution.scss'],
})

export class IndustryDistribution implements OnInit, AfterViewInit {
    @Input('industryDistribution') industryDistribution: any;
    @Input('updateTime') updateTime: any;
    constructor(
        private cdref: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
    }
    ngAfterViewInit(): void {
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                this.updateBarChart();
            }, 300)
        }
    }
    updateBarChart() {
        const totalWidth = Math.floor($('#container-industry-distribution')[0].offsetWidth) / 2 - 20;
        let min = 100, max = 0;
        this.industryDistribution.forEach((item: any) => {
            if (min > item.assetPercent) {
                min = item.assetPercent;
            }
            if (max < item.assetPercent) {
                max = item.assetPercent;
            }
        });
        if (max !== min) {
            const unit = Math.floor(max / min);
            const unitWidth =  (totalWidth - 50) / (unit + 1);
            this.industryDistribution.forEach((item: any) => {
                item.width =  Math.floor((item.assetPercent / min) * unitWidth) + 'px';
            })
        } else {
            const unitWidth = totalWidth / 100;
            this.industryDistribution.forEach((item: any) => {
                item.width = (item.assetPercent * unitWidth) + 'px';
            })
        }
        this.cdref.detectChanges();
    }
}
